import { Component, OnInit, ViewEncapsulation, EventEmitter, ViewChild, Input, Output, OnChanges, SimpleChanges, SimpleChange } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DataManager, WebApiAdaptor, Query, DataOptions, ReturnOption, UrlAdaptor } from '@syncfusion/ej2-data';
import { DropDownList } from '@syncfusion/ej2-dropdowns';
import { createElement, extend, Ajax, L10n, loadCldr } from '@syncfusion/ej2-base';
import * as momenttz from 'moment-timezone';
import { Timezone } from '@syncfusion/ej2-schedule';
import { Environment } from '../../app.environment';

import { MyModal } from '../../components/modal/modal';
import { Api, Session } from '../../services/index';
import { ProviderBio } from '../../models/provider';
import { EJ2Instance, Schedule, RecurrenceEditor, PopupOpenEventArgs, EventRenderedArgs, RenderCellEventArgs } from '@syncfusion/ej2-angular-schedule';
import { EventSettingsModel, ScheduleComponent, View } from '@syncfusion/ej2-angular-schedule';

import * as numberingSystems from './numberingSystems.json';
import * as gregorian from './ca-gregorian.json';
import * as numbers from './numbers.json';
import * as timeZoneNames from './timeZoneNames.json';
import * as currencies from './currencies.json';



import { NotificationsService } from 'angular2-notifications';
import { SavePatientSchedule, Added, Changed, ScheduleRequest, CreateScheduleRequest, ScheduleResponse, AvailableProviderQueue, ProviderScheduleForPatient, ProviderScheduleSearch, ScheduleReservation } from '../../models';


import { isNullOrUndefined } from 'util';
import { Observable } from 'rxjs';
loadCldr(numberingSystems, gregorian, numbers, timeZoneNames);

L10n.load({
  'es': {
    'schedule': {
      "day": "DÃ­a",
      "week": "Semana",
      "workWeek": "Semana de trabajo",
      "month": "Mes",
      "agenda": "Agenda",
      "weekAgenda": "Agenda de la semana",
      "workWeekAgenda": "Agenda de la semana laboral",
      "monthAgenda": "Agenda del Mes",
      "today": "Hoy",
      "noEvents": "No hay eventos",
      "emptyContainer": "No hay eventos programados para este dÃ­a.",
      "allDay": "Todo el dia",
      "start": "comienzo",
      "end": "Fin",
      "more": "MÃ¡s",
      "close": "Cerrar",
      "cancel": "Cancelar",
      "noTitle": "(Sin tÃ­tulo)",
      "delete": "Borrar",
      "deleteEvent": "Eliminar evento",
      "deleteMultipleEvent": "Eliminar mÃºltiples eventos",
      "selectedItems": "ArtÃ­culos seleccionados",
      "deleteSeries": "Eliminar series",
      "edit": "Editar",
      "editSeries": "Editar serie",
      "editEvent": "Editar evento",
      "createEvent": "Crear",
      "subject": "Tema",
      "addTitle": "AÃ±adir tÃ­tulo",
      "moreDetails": "MÃ¡s detalles",
      "save": "Salvar",
      "editContent": "Â¿Quieres editar solo este evento o toda la serie?",
      "deleteRecurrenceContent": "Â¿Quieres borrar solo este evento o toda la serie?",
      "deleteContent": "Â¿EstÃ¡s seguro de que quieres eliminar este evento?",
      "deleteMultipleContent": "Â¿Seguro que quieres borrar los eventos seleccionados?",
      "newEvent": "Nuevo evento",
      "title": "TÃ­tulo",
      "location": "UbicaciÃ³n",
      "description": "DescripciÃ³n",
      "timezone": "Zona horaria",
      "startTimezone": "Iniciar zona horaria",
      "endTimezone": "Zona horaria final",
      "repeat": "Repetir",
      "saveButton": "Salvar",
      "cancelButton": "Cancelar",
      "deleteButton": "Borrar",
      "recurrence": "ReapariciÃ³n",
      "wrongPattern": "El patrÃ³n de recurrencia no es vÃ¡lido.",
      "seriesChangeAlert": "Los cambios realizados en instancias especÃ­ficas de esta serie se cancelarÃ¡n y esos eventos volverÃ¡n a coincidir con la serie.",
      "createError": "La duraciÃ³n del evento debe ser mÃ¡s corta que la frecuencia con la que se produce. Acorte la duraciÃ³n o cambie el patrÃ³n de recurrencia en el editor de eventos de recurrencia.",
      "recurrenceDateValidation": "Algunos meses tienen menos de la fecha seleccionada. Para estos meses, la ocurrencia caerÃ¡ en la Ãºltima fecha del mes.",
      "sameDayAlert": "Dos ocurrencias del mismo evento no pueden ocurrir el mismo dÃ­a.",
      "editRecurrence": "Editar Recurrencia",
      "repeats": "Repite",
      "alert": "Alerta",
      "startEndError": "La fecha de finalizaciÃ³n seleccionada se produce antes de la fecha de inicio.",
      "invalidDateError": "El valor de fecha introducido no es vÃ¡lido.",
      "ok": "De acuerdo",
      "occurrence": "Ocurrencia",
      "series": "Serie",
      "previous": "Anterior",
      "next": "Siguiente",
      "timelineDay": "DÃ­a de la lÃ­nea de tiempo",
      "timelineWeek": "LÃ­nea de tiempo semana",
      "timelineWorkWeek": "LÃ­nea de tiempo de trabajo",
      "timelineMonth": "Mes de la lÃ­nea de tiempo"
    },
    "recurrenceeditor": {
      "none": "Ninguna",
      "daily": "Diario",
      "weekly": "semanal",
      "monthly": "Mensual",
      "month": "Mes",
      "yearly": "Anual",
      "never": "Nunca",
      "until": "Hasta",
      "count": "Contar",
      "first": "First",
      "second": "Segundo",
      "third": "Tercero",
      "fourth": "Cuarto",
      "last": "Ãšltimo",
      "repeat": "Repetir",
      "repeatEvery": "Repite cada",
      "on": "Repita en",
      "end": "Fin",
      "onDay": "DÃ­a",
      "days": "Dias)",
      "weeks": "Semanas)",
      "months": "Meses)",
      "years": "AÃ±os)",
      "every": "cada",
      "summaryTimes": "veces)",
      "summaryOn": "en",
      "summaryUntil": "hasta",
      "summaryRepeat": "Repite",
      "summaryDay": "dias)",
      "summaryWeek": "semanas)",
      "summaryMonth": "meses)",
      "summaryYear": "aÃ±os)"
    }
  }
});

@Component({
  selector: 'app-scheduler',
  templateUrl: './scheduler.component.html',
  styleUrls: ['./scheduler.component.css']
})


export class SchedulerComponent implements OnInit {

  @ViewChild('confirmSchedule') public _modalconfirmSchedule: MyModal;
  @ViewChild('scheduleObj') scheduleObj: ScheduleComponent;

  linkToProviderScheduleData: string;
  linkToAllScheduleData: string;
  lineOfBusiness: string;
  stateCodeSearch: string;
  providerSearchId: number;
  scheduledProviderBio: ProviderBio;
  scheduleSourceData: any;
  requestedProviderId: number;
  requestScheduleToChange: ProviderScheduleForPatient;
  loading: boolean = false;
  reservationId: Number;
  searchType: string = 'false';
  //New after adding in request schedule queue 
  newScheduleRequest: CreateScheduleRequest;
  langSelected: string = '';
  public eventSettings: EventSettingsModel;
  public selectedDate: Date;
  public currentDate: Date = new Date(2018, 1, 12);
  timezone: any = (momenttz.tz.zone(momenttz.tz.guess()));
  public headers: Object[] = [];
  public currentView: View = 'MonthAgenda';
  public agendaTemplate: string = '<div class="subject" style="background: ${CategoryColor};">${Subject} - ${ProviderSpecialty}</div>' +
  '<div class="group">${EventType}</div>' +
  '<div class="time">${StartTime.toLocaleString()} </div>';

  showQuickInfo: boolean;
  _subscription: any;
  constructor(private env: Environment,
    public session: Session,
    public api: Api,
    public notification: NotificationsService,
    private route: ActivatedRoute,
    private router: Router) {


    this.searchType = this.route.snapshot.params['searchType'] || false;

    this.showQuickInfo = false;
    this.scheduledProviderBio = new ProviderBio();
    let myDate = new Date();
    myDate.setDate(myDate.getDate() + 1);
    let curDate = momenttz(myDate).format('YYYY-MM-DD');
    this.selectedDate = new Date(myDate);
    this.stateCodeSearch = this.session.clientIntake.currentState;
    this.lineOfBusiness = this.session.clientIntake.lineOfBusiness;

    this._subscription = session.langChange.subscribe((value) => { 
      this.langSelected = value; 
      this.scheduleObj.locale = this.langSelected;
    }); 
   
    

    if (this.session.intakeRequestedProviderId) {
      this.providerSearchId = this.session.intakeRequestedProviderId;
      this.linkToProviderScheduleData = this.env.settings.apiUrl + 'v2/schedule/search/' + this.lineOfBusiness + '/type/' + this.session.intakeBhVisitModality + '/state/' + this.stateCodeSearch + '/provider/' + this.providerSearchId + '/patient/' + this.session.intakeBhType;
    } else {
      // this.linkToProviderScheduleData = this.env.settings.apiUrl + 'v2/schedule/' + this.lineOfBusiness + '/type/' + this.session.intakeBhVisitModality + '/state/' + this.stateCodeSearch + '/provider/0/patient/~';
      this.linkToProviderScheduleData = this.env.settings.apiUrl + 'v2/schedule/search/' + this.lineOfBusiness + '/type/' + this.session.intakeBhVisitModality + '/state/' + this.stateCodeSearch + '/patient/' + this.session.intakeBhType;
    }



  }

  ngOnInit() {
    this.scheduleObj.timezone = this.timezone.name;
    this.scheduleObj.locale = this.session.selectedLang;
    this.headers.push({ 'Content-Type': 'application/json' });
    this.headers.push({ 'Accept': 'application/json' });



    this.eventSettings = {
      enableTooltip: true,
      dataSource: new DataManager({
        url: this.linkToProviderScheduleData,
        crossDomain: true,
        headers: this.headers,
        adaptor: new ProviderAdaptor
      })
    };





  }



  onPopupOpen(args: PopupOpenEventArgs): void {


    args.cancel = true;



  }
  onRenderCell(args: RenderCellEventArgs): void {
    //need to look into this more when using agenda templ
    let myDate = new Date();
    myDate.setDate(myDate.getDate() + 1);
    if (args.date < myDate) {
      args.element.setAttribute('aria-readonly', 'true');
      args.element.classList.add('e-read-only');
    }
  }
  public onNavigating(args: any): void {
    // console.log(args);
  }
  public onCreated(args: any): void {

  }
  public onActionBegin(args: any): void {
    // console.log(args);
  }
  public onCellClick(args: any): void {
    //console.log(args);
  }
  public onEventClick(args: any): void {
    //console.log(args);
    if (!args.event) {
      args.cancel = true;
    } else {
      let myDate = new Date();
      myDate.setDate(myDate.getDate() + 1);

      if (args.event.StartTime < myDate) {
       this.notification.alert('Invalid Date Selected', 'Appointments must be at least 24 hours in the future.');
       args.cancel = true;
      } else {
        this.scheduledProviderBio = new ProviderBio();
        let event: any = args.event;
        this.scheduleSourceData = args.event;

        // if (event.ProviderAvatar) {
        //   let _base64 = event.ProviderAvatar.toString();
        //   this.scheduledProviderBio.avatarBase64 = "data:image/png;base64," + event.ProviderAvatar;
        // }

        // this.scheduledProviderBio.name = event.ProviderName;
        // this.scheduledProviderBio.specialty = event.ProviderSpecialty;
        // this.scheduledProviderBio.providerBio = event.ProviderBio;

        this.newScheduleRequest = new CreateScheduleRequest();
        this.newScheduleRequest.availabilityId = event.ProviderSourceScheduleId;
        this.newScheduleRequest.scheduleId = event.Id;
        this.newScheduleRequest.startDate = momenttz.utc(event.StartTime).format();
        this.newScheduleRequest.endDate = momenttz.utc(event.EndTime).format();
        this.newScheduleRequest.availabilityType = this.session.intakeBhVisitModality;
        this.newScheduleRequest.lineOfBusiness = this.lineOfBusiness;
        this.newScheduleRequest.patientId = Number(this.session.patient.userId);
        this.newScheduleRequest.providerId = event.ProviderId;
        this.newScheduleRequest.specialtyType = this.session.intakeBhType;
        this.newScheduleRequest.intakeId = Number(this.session.serverIntake.intakeId);

        this.session.intakeSchedule = this.newScheduleRequest;

        let _providerId = Number(event.ProviderId);
        this.session.providerBio = new ProviderBio();
        this._modalconfirmSchedule.open();
      }

    }


  }
  viewMore() {
    this._modalconfirmSchedule.close();
  }

  scheduleSelectedVisit() {
    this.loading = true;


    let reservation = new ScheduleReservation();
    reservation.appointmentDate = new Date(this.newScheduleRequest.startDate);
    reservation.patientId = this.session.patient.userId;
    reservation.providerId = Number(this.newScheduleRequest.providerId);
    reservation.scheduleId = Number(this.newScheduleRequest.scheduleId);

    //this.reservationId = -1;
    this.api.makeScheduleRequest(this.newScheduleRequest).subscribe(res => {
      if (res.id) {
        this.session.scheduleReuestId = res.id;
        reservation.requestId = Number(res.id);
        console.log('Schedule request complete')
        // this.api.startReserveSchedule(reservation).subscribe(reserve => {
        //   if(reserve){
        //     this.reservationId = Number(reserve);

        //     console.log('Schedule reservation started')

        //   }

        // }, (error) => {
        //   this.loading = false;
        // });
        this.session.intakeScheduleDate = this.newScheduleRequest.startDate;
        this.session.intakeSchedule = this.newScheduleRequest;
        this._modalconfirmSchedule.close();
        this.loading = false;
       
        this.router.navigate(['/disclosure']);
      }
    }, (error) => {
      this.notification.error('An error occured while saving appointment.');
      this.loading = false;
      this._modalconfirmSchedule.close();
    });


  }

  removeExceptionFormat(stringtoClear): string {
    //todo do this right later
    let re1 = /:/gi;
    let re2 = /-/gi;
    let strRecurrenceRule1 = stringtoClear.replace(re1, "");
    let strRecurrenceRule2 = strRecurrenceRule1.replace(re2, "");
    let strRecurrenceRule = strRecurrenceRule2;
    return strRecurrenceRule;
  }

}

class ProviderAdaptor extends UrlAdaptor {
  public processResponse(): Object {
    let i: number = 0;
    //calling base class processResponse function
    let original = super.processResponse.apply(this, arguments);
    let fixedData: Object[] = [];
    let phsOriginal: Object[] = [];
    if (original){
      for (let i = 0; i < original.length; i++) {
        if (original[i].isLCSW && original[i].visitType === 'Available Video/Phone') {
          phsOriginal.push(original[i]);
        }
      }
    }

    //Process the response from ChangeScheduleByType(..)
    for (let prop in phsOriginal) {
      if (prop != null && prop !== 'results') { continue; }
      let results = phsOriginal[prop];
      if (results instanceof Array) {
        let size = results.length;
        for (let i = 0; i < results.length; i++) {
          fixedData.push(results[i]);
        }
        return fixedData;
      }
    }


    phsOriginal.forEach((item: Object) => {
      let tz: Timezone = new Timezone();
      let myDate = new Date();
      myDate.setDate(myDate.getDate() + 1);
     
      let checkTime = new Date(item['startDate']);


      if (checkTime >= myDate) {

        // let newStartDate = new Date(item['startTime']);
        // newStartDate.setDate(newStartDate.getDate() + 3);
        // item['startTime'] = newStartDate;

        // let newEndDate = new Date(item['endTime']);
        // newEndDate.setDate(newEndDate.getDate() + 3);
        // item['endTime'] = newEndDate;


        let newStartDate = new Date(item['startDate']);
        //item['shiftStart'] = newStartDate;

        let newEndDate = new Date(item['endDate']);
        //item['shiftEnd'] = newEndDate;
        let sch = {
          EventType: item['visitType'],
          Subject: item['fullName'],
          StartTime: tz.removeLocalOffset(newStartDate),
          EndTime: tz.removeLocalOffset(newEndDate),
          Description: (item['description']) ? item['description'] : item['visitType'],
          Id: item['scheduleId'],
          CategoryColor: this.getCatagoryColor(item['visitType']),
          ProviderName: item['fullName'],
          ProviderSpecialty: item['specialty'], //item['providerBio']['specialty'],
          //ProviderBio: item['providerBio']['providerBio'],
          //ProviderAvatar: item['providerBio']['avatarBase64'],
          ProviderSourceScheduleId: item['providerScheduledAvailabilityId'],
          ProviderId: item['providerId'],
          SourceStart: item['shiftStart'],
          SourceEnd: item['endDate']
        }
        fixedData.push(sch);

      }


    });
    return fixedData;
  }
  beforeSend(dm: DataManager, request: any) {
    request.setRequestHeader("Authorization", 'Bearer ' + Api.bearerToken);   //sets the request header 
  }


  public getCatagoryColor(type): string {
    let color = '';
    switch (type) {
      case 'Phone Only':
        color = '#0080bb'
        break;
      case 'Video/Phone':
        color = '#009933'
        break;
      case 'Overflow':
        color = '#e6e600'
        break;
      case 'Unavailable':
        color = '#cc3300'
        break;
      case 'Available Phone Only':
        color = '#33cccc'
        break;
      case 'Available Phone/Video':
        color = '#00ccff'
        break;
      case 'Available Video/Phone':
        color = '#00ccff'
        break;
      case 'Scheduled Phone Only':
        color = '#ffcc00'
        break;
      case 'Scheduled Phone':
        color = '#ffcc00'
        break;
      case 'Scheduled Video/Phone':
        color = '#ff9933'
        break;
      case 'Scheduled Video':
        color = '#ff9933'
        break;
      default:
        color = '#0033cc'
        break;
    }
    return color;
  }


}
